<template>
  <div v-resize="setContentHeight">
    <v-toolbar dark color="primary" class="pr-1">
      <v-btn icon @click="customGoBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>Booking Details</v-toolbar-title>
    </v-toolbar>

    <div v-if="area" ref="bookingDetailsScrollable" class="scrollable">
      <v-card
        flat
        style="border-bottom-right-radius: 5px; border-bottom-left-radius: 5px"
      >
        <v-img
          :src="`${areaImagePath}${area.areaImageUrls[0]}`"
          max-height="154"
        ></v-img>

        <!-- <v-img :src="require(`@/assets/images/trl-study-lounge.png`)" max-height="154"></v-img> -->

        <div class="pa-4 text-small">
          <div
            class="font-weight-bold mb-1 text-title-black"
            style="font-sizex: initial"
          >
            {{ formatLocation(area.areaName, area.floor) }}
          </div>
          <div
            v-if="area.ignoreHolidays"
            class="subtitle font-weight-bold mb-2"
            style="font-sizex: initial"
          >
            Extended hours zone – available on Public Holidays
          </div>
          <div>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-library</v-icon>
              </v-col>
              <v-col>{{ area.branchName }}</v-col>
            </v-row>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-calendar-month</v-icon>
              </v-col>
              <v-col>{{ formatDate(area.startTime) }}</v-col>
            </v-row>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-smaller">mdi-clock-outline</v-icon>
              </v-col>
              <v-col>{{ formatPeriod(area.startTime, area.endTime) }}</v-col>
            </v-row>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-seat</v-icon>
              </v-col>
              <v-col>{{
                formatAvailability(
                  area.availableSeatsCount,
                  area.totalSeatCount
                )
              }}</v-col>
            </v-row>

            <v-row dense v-if="area.areaInformation && area.areaInformation.directionalInfo">
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-directions</v-icon>
              </v-col>
              <v-col>{{ area.areaInformation.directionalInfo }}</v-col>
            </v-row>

            <v-row dense v-if="hasAvailableWheelchairSeats">
              <v-col class="col-1">
                <v-img
                  :src="`${this.iconPath}accessibility-icon.png`"
                  max-height="35"
                  max-width="15"
                ></v-img>
              </v-col>
              <v-col>
                Wheelchair friendly seats available
              </v-col>
            </v-row>

            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-information</v-icon>
              </v-col>
              <v-col>
                Your seat number will be assigned after a booking is made
                successfully.
              </v-col>
            </v-row>

            <v-row dense v-if="area.areaConstraints">
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-account-alert</v-icon>
              </v-col>
              <v-col>
                For patrons aged {{ area.areaConstraints.ageAboveOrEqual }} and above
              </v-col>
            </v-row>
            <!-- <v-row v-if="windowSettings.showBloombergEndingSoonInfo && (area.areaName == 'Bloomberg Terminal')" dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-information-outline</v-icon>
              </v-col>
              <v-col>
                We are sorry that this database will not be available from 27 October 2021. If you have any queries, please send an email to our Customer Relations Officer at <a href='mailto: enquiry@nlb.gov.sg'>enquiry@nlb.gov.sg</a>
              </v-col>
            </v-row> -->

            <!-- <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-timer-sand</v-icon>
              </v-col>
              <v-col>
                {{area.maxDuration}} (Hour : Minute)
                <v-btn icon x-small class="ml-5" color="primary">
                  <v-icon class="icon-smallx">mdi-square-edit-outline</v-icon>Edit
                </v-btn>
              </v-col>
            </v-row>-->
          </div>

          <div class="button-group mt-4">
            <v-row>
              <v-col>
                <v-btn
                  @click="viewMaps(area)"
                  dark
                  large
                  color="primary"
                  class="px-5"
                  block
                >
                  <v-icon left dark>mdi-map-search</v-icon>View Maps
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  v-if="authenticated"
                  key="1"
                  @click="confirmBooking"
                  dark
                  large
                  color="orange"
                  class
                  block
                >
                  <v-icon left dark>mdi-calendar-check</v-icon>Book
                </v-btn>

                <v-btn
                  v-else
                  key="2"
                  @click="loginAuth"
                  dark
                  large
                  color="orange"
                  class
                  block
                >
                  <v-icon left dark>mdi-login-variant</v-icon>Login to Book
                </v-btn>
              </v-col>
            </v-row>

             <!-- Seat Selection popup -->
            <v-row justify="center">
              <v-dialog v-model="confirmDialog.show" max-width="100%">
                <v-card class="py-2">
                  <v-card-title class="mb-3">{{
                    confirmDialog.message
                  }}</v-card-title>

                  <v-card-subtitle class="red--text">{{
                    confirmDialog.termsAndConditions
                  }}</v-card-subtitle>

                  <div @click="inputPopupSelectSeat.show = true">
                    <div
                      v-if="isPreferredSeatNotAvailable && selectedSeatName"
                      class="label px-8"
                    >
                      <span class="preferred-seat-msg"
                        >{{ preferredSeatNotAvailableMsg() }}<br /><br
                      /></span>
                    </div>

                    <v-text-field
                      prepend-inner-icon="mdi-seat-passenger"
                      :value="inputPopupSelectSeat.selectedItem.name"
                      class="px-8"
                      readonly
                    ></v-text-field>

                    <!--  TODO:Make InputPopupSelect component generic for icon requirement, and remove this eventually -->
                    <InputPopupSelectWithIcon
                      title="Preferred Seat"
                      :list="modifiedAvailableSeatIds"
                      :select.sync="inputPopupSelectSeat"
                      maxWidth="220px"
                    />
                    </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      xcolor="primary"
                      text
                      @click="confirmDialog.show = false"
                      >Cancel</v-btn
                    >

                    <v-btn color="primary" text @click="book(area)"
                      >Confirm</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import formatters from "@/helpers/formatters";
import apiHelper from "@/helpers/apiHelper";
import validators from "@/helpers/validators";
import routerHelper from "@/helpers/routerHelper";
import InputPopupSelect from "@/components/InputPopupSelect";
import InputPopupSelectWithIcon from "@/components/InputPopupSelectWithIcon";

export default {
  name: "BookingDetails",
  components: {
    InputPopupSelect,
    InputPopupSelectWithIcon,
  },
  props: {
    selectedSeatName: String,
  },
  data: () => ({
    area: null,
    viewMapDialog: false,
    mapTabs: 0,
    seat: null,
    isPreferredSeatNotAvailable: false,
    isPreferredNewSeatSelection: false,
    hasAvailableWheelchairSeats: false,
    hasDirectionalInfo: false,
    confirmDialog: {
      show: false,
      message: "",
      termsAndConditions: "",
    },
    inputPopupSelectSeat: {
      show: false,
      selectedItem: {
        name: null,
        code: null,
      },
    },
    noPreferredSeat: { name: "No preferred seat", code: "any" },
  }),
  computed: {
    ...mapState(["selectedArea", "settings", "locationInfoFromQrCode"]),
    ...mapGetters(["mode", "isEmailMobileLogin"]),
    modifiedAvailableSeatIds() {
      return [this.noPreferredSeat, ...this.area.availableSeats];
    },
    },
  methods: {
    ...mapMutations(["updatePreCasAuthState", "updateAccountInfo"]),
    viewMaps(area) {
      this.$router.push({
        name: "ViewMaps",
        params: {
          mapFileNames: area.areaMapUrls,
        },
      });
    },
    resetSeat() {
      if (this.area.availableSeats) {
        this.inputPopupSelectSeat.selectedItem =
          this.modifiedAvailableSeatIds[0];

        this.hasAvailableWheelchairSeats =
          this.area.availableSeats.some(seat => seat.seatInformation?.isWheelchairFriendlySeat);
      }

      if (this.onsiteMode) {
        //Get seat code from QRCode
        if (this.locationInfoFromQrCode) {
          const locationInfo = this.locationInfoFromQrCode;

          if (locationInfo.seatCode) {
            this.seat = this.area.availableSeats.find(
              (x) =>
                x.code.toLowerCase() === locationInfo.seatCode.toLowerCase()
            );

            if (this.seat) {
              this.inputPopupSelectSeat.selectedItem = this.seat;
              this.isPreferredSeatNotAvailable = false;
            } else {
              this.isPreferredSeatNotAvailable = true;
            }
          }
        }
      }
    },
    loginAuth() {
      routerHelper.verifyAuthRoute(this.$route.name);
    },
    customGoBack() {
      if (this.$route.query.reloaded) {
        //Prevent redirecting back to CAS login page after logging in
        this.goHome();
      } else {
        this.goBack();
      }
    },
    formatLocation(area, floor) {
      return `${area}, Level ${floor}`;
    },
    formatPeriod(fromDateString, toDateString) {
      return formatters.formatPeriod(fromDateString, toDateString);
    },
    formatAvailability(availableSeatsCount, totalSeatCount) {
      return `${availableSeatsCount}/${totalSeatCount}`;
    },
    formatDate(dateString) {
      return formatters.formatDate(dateString);
    },
    preferredSeatNotAvailableMsg() {
      if (this.selectedSeatName) {
        return window.$msg.preferSeatUnavailable.replace(
          "{selectedSeat}",
          this.selectedSeatName
        );
      }
      return null;
    },
    confirmBooking() {
      this.confirmDialog.message = window.$msg.preferredSeat;
      this.confirmDialog.show = true;
      if (this.area.areaInformation) {
        this.confirmDialog.termsAndConditions = this.area.areaInformation.termsAndConditions;
      }
      else {
        this.confirmDialog.termsAndConditions = null;
      } 
    },
    async book(area) {
      this.confirmDialog.show = false;

       if (this.isEmailMobileLogin) {
         this.updateSystemAlert({
           show: true,
           success: false,
           message: window.$msg.notEligbleToBookSeat,
         });
       } else {
         //const seatCode = this.mode.seatCode;
         const seatCode = this.inputPopupSelectSeat.selectedItem.code;

         const response = await apiHelper.book(
           area.areaId,
           area.startTime,
           area.durationInMinutes,
           area.branchId,
           seatCode
         );

         const tabNo = validators.isToday(area.startTime, this.time.nowMoment)
           ? 0
           : 1;

         //commonResponseHandler is not used in this case, because this handler is a bit different
         //There are two response when booking success, preferred seat is true then return success, else return fail
         if (response && response.data) {
           if (response.data.isPreferredSeat) {
             this.updateResult({
               show: true,
               success: true,
               title: window.$msg.bookSuccess,
             });
             this.updateAccountInfo(response.data.accountInfo);
           } else {
             this.updateResult({
               show: true,
               success: false,
               title: window.$msg.bookFail,
               message: response,
             });
           }
           this.$router.push({ name: "MyBookings", params: { tabNo: tabNo } });
         } else {
           this.updateResult({
             show: true,
             success: false,
             title: window.$msg.bookFail,
             message: response,
           });
         }

         // this.commonResponseHandler(
         //   response,
         //   window.$msg.bookSuccess,
         //   window.$msg.bookFail,
         //   null,
         //   () =>
         //     this.$router.push({ name: "MyBookings", params: { tabNo: tabNo } }),
         //   null
         // );
       }
    },
    setContentHeight() {
      if (this.$refs.bookingDetailsScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.bookingDetailsScrollable.style.height = contentHeight + "px";
      }
    },
  },
  activated() {
    this.area = this.selectedArea;
    this.resetSeat();
    this.$nextTick(() => this.setContentHeight());
  },
  beforeRouteLeave(to, from, next) {
    const inputs = [this.inputPopupSelectSeat, this.confirmDialog];

    for (let i of inputs) {
      if (i != null && i.show) {
        i.show = false;

        next(false);
        return;
      }
    }

    next();
  },
};
</script>

<style scoped>
.button-group .col {
  margin: 5px;
  padding: 0px;
}

.preferred-seat-msg {
  color: red !important;
}
</style>
